import { ApplicationState } from "../../store";
import {
    getLanguageCode,
    getLanguageResourceGeneralStrings
} from "../../store/LanguageLocale/selector";
import {
    getIsAppointmentConfirmed
} from "../../store/Appointment/selectors";
import { getDisplayProfilePicturesValue } from "../../store/AdminOptions/selectors";
import { Routes } from "../../constants/routes";
import { connect } from "react-redux";
import { AppointmentConfirmation } from "./AppointmentConfirmation.component";
import { Dispatch } from "redux";
import {
    IAppointmentConfirmationMapStateProps,
    IAppointmentConfirmationMapDispatchProps
} from "./Types";
import { getLoadingSpinnerVisibilityState } from "../../store/LoadingSpinner/selectors";
import { TypeOfFinalTransaction, ClientEventScreen } from "../../dtos/KioskDtos.dtos";
import { redirectToSurvey } from "../../sagas/surveyRedirectSaga";
import { push } from "../../store/Routing/actions";
import { postConfirmAppointmentToServer } from "../../sagas/Appointments/actions";
/**
 * @description Maps necessary store values as properties for this component.
 * @param {ApplicationState} state
 */
const mapStateToProps = (state: ApplicationState): IAppointmentConfirmationMapStateProps => {
    return {
        lang: getLanguageCode(state.localeText),
        textString: getLanguageResourceGeneralStrings(state.localeText),
        timeBeforeToCheckIn: state.adminOptions.checkInDelay,
        appointments: state.appointment.appointments,
        isAppointmentConfirmed: getIsAppointmentConfirmed(state.appointment),
        isLoadingSpinnerActive: getLoadingSpinnerVisibilityState(state.loadingSpinner),
        showProfilePicture: getDisplayProfilePicturesValue(state.adminOptions),
        sites: state.clinicInformation.sites,
        isMultiSiteEnabled: state.clinicInformation.myleClinicSettings.enableKioskMultiSiteCheckin
    };
}

/**
 * @description Maps dispatch function as properties for this component.
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: Dispatch): IAppointmentConfirmationMapDispatchProps => ({
    confirmSelectedAppointment: (appointmentId: string[]) => dispatch(postConfirmAppointmentToServer(appointmentId)),

    cancel: () => dispatch(redirectToSurvey(push(Routes.introduction), TypeOfFinalTransaction.CancelledOnTheirOwn, ClientEventScreen.ExistingAppointmentConfirmation)),

    return: (typeOfFinalTransaction: TypeOfFinalTransaction) => {
        // Client.logInteractionEvent(InteractionType.UnableToConfirmExistingAppointment)
        dispatch(redirectToSurvey(push(Routes.introduction), typeOfFinalTransaction));
    }
});

export default connect<IAppointmentConfirmationMapStateProps, IAppointmentConfirmationMapDispatchProps, void>(mapStateToProps, mapDispatchToProps)(AppointmentConfirmation);


// WEBPACK FOOTER //
// ./src/components/AppointmentConfirmation/AppointmentConfirmation.container.ts